/**
 * 下層ページの背景を起動
 */
import { breakpoint, containerID } from '@/_modules/utils/variables';

export default class subBg {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'subBg';
    this.init();
  }

  /**
   * 初期
   */
  init() {
    const id = this.randomArr([0, 1, 2, 3, 4]);

    //背景を呼び出す
    /*
        @param
        0 ポリゴン
        1 ワイヤーフレーム
        2 ライン
        3 ボックス
        4 液状
    */

    window.tokyo.pics.startSub(id);
  }

  // ----------------------------------------
  // minからmaxまでランダム int
  // ----------------------------------------
  randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  // ----------------------------------------
  // 配列の中ランダム
  // ----------------------------------------
  randomArr(arr) {
    return arr[this.randomInt(0, arr.length - 1)]
  }
}